import React from 'react';
import { Shield, Check } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-[#FEFCF6] border-y border-[#E8DFD0] text-center" data-id="element-147">
      <div className="max-w-[600px] mx-auto" data-id="element-148">
        <div className="inline-flex items-center justify-center p-4 bg-[#F0F4EC] rounded-full mb-6 border border-[#2D5A3D]/20" data-id="element-149">
          <Shield className="w-10 h-10 text-[#2D5A3D]" data-id="element-150" />
        </div>

        <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#2C1810] mb-2" data-id="element-151">
          Garantía "Siente la Diferencia" de 7 Días
        </h2>
        <h3 className="text-[#2D5A3D] font-bold text-lg mb-6 uppercase tracking-wide" data-id="element-152">
          🛡️ 100% LIBRE DE RIESGO
        </h3>

        <div className="bg-white p-8 rounded-xl border border-[#E8DFD0] text-left space-y-4 mb-8 shadow-sm" data-id="element-153">
          <p className="text-[#5C4A3A]" data-id="element-154">
            Prueba el manual. Usa los protocolos. Ponlos a prueba durante 7 días
            completos.
          </p>
          <p className="text-[#2C1810] font-bold text-lg" data-id="element-155">
            Si en 7 días no sientes ninguna diferencia — ni siquiera pequeña —
            te devolvemos el 100% de tu dinero.
          </p>
          <p className="text-[#5C4A3A]" data-id="element-156">
            Sin preguntas. Sin trámites. Sin letra chica.
          </p>

          <div className="bg-[#F0F4EC] p-4 rounded-lg border-l-4 border-[#2D5A3D] mt-4" data-id="element-157">
            <p className="text-[#2D5A3D] font-medium italic" data-id="element-158">
              "No tienes nada que perder. Y potencialmente... tu salud que
              recuperar."
            </p>
          </div>
        </div>

        <p className="text-[#8B7355] text-sm italic max-w-md mx-auto" data-id="element-159">
          ¿Por qué ofrecemos esta garantía? Porque Shanon lleva 20 años viendo
          estos resultados en su clínica. La confianza en los protocolos es
          absoluta. El único riesgo real es no intentarlo.
        </p>
      </div>
    </section>;
}